import { render, staticRenderFns } from "./addNoteLocal.vue?vue&type=template&id=620209f9&"
import script from "./addNoteLocal.vue?vue&type=script&lang=js&"
export * from "./addNoteLocal.vue?vue&type=script&lang=js&"
import style0 from "./addNoteLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports